import React from 'react';
import Staff from '../Staff/Staff';
import * as urlHelper from '../../util/url';
import transLoader from '@beisen/i18n-translation-loader';
require('./NextApprover.scss');
/*
按钮参数上给出是否有下一节点审批人
如果需要请求 请求后将取得 单选还是多选
*/

const defaultTranslation = {
    nextAppFaildTip: '获取下一节点审批人失败',
    searchFailed: '搜索失败'
};

class NextApprover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appointApproversText: null,
            appointApproversValue: null,
            appointApproversAvatars: null,
            approvers: []
        };
        this.handleAppointApproversChange = this.handleAppointApproversChange.bind(this);
        this.fetchSearchUsers = this.fetchSearchUsers.bind(this);
        this.clearState = this.clearState.bind(this);
        this.assigneeType = 0;
        this.assigneeExpr = '';
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            nextAppFaildTip: 'approval.nextAppFaildTip',
            searchFailed: 'tip.searchFailed'
        }), props.translation);
    }

    componentDidMount() {
        const params = {
            method: 'GET',
            credentials: 'same-origin'
        };
        const { translation } = this;

        const failureCallBack = function(res) {
            this.props.actions.showTip({ message: translation.nextAppFaildTip, type: 'error' });
            this.props.stopLoadForField && this.props.stopLoadForField();
        }.bind(this);

        const successCallBack = function(data) {
            this.assigneeType = data.assigneeType;
            this.assigneeExpr = data.assigneeExpr;
            this.selfFilter = !data.isRequest; // 是否需要重新请求接口 还是自己过滤
            const res = data && data.approvers || [];
            this.defaultUsers = this.formatApproversData(res);
            this.setState({ approvers: this.defaultUsers,singleSelect: !data.isMultiple },() => {
                this.props.stopLoadForField && this.props.stopLoadForField();
            });
        }.bind(this);

        window.CommonFetch(this.getFetchUrl(), params, successCallBack, failureCallBack, this.props.analysisData);
    }

    handleAppointApproversChange(obj) {
        this.setState({ appointApproversText: obj.text,appointApproversValue: obj.value, appointApproversAvatars: obj.avatars },() => {
            this.props.onChange && this.props.onChange(obj);
        });
    }

    getFetchUrl(query) {
        const queryV = query ? ('&query=' +  query) : '';
        return urlHelper.keepHttpsProtocolSame('/api/v1/WF/ApprovalCentre/GetAppointApprovers?app='
                        + window.BSGlobal.application
                        + '&type=' + this.props.type
                        + '&workflowTaskId=' + this.props.workflowTaskId
                        + '&actionValue=' + this.props.actionValue
                        + '&isSystemAction=' + this.props.isSystemAction
                        + '&assigneeType=' + this.assigneeType
                        + '&assigneeExpr=' + this.assigneeExpr
                        + queryV);
    }

    formatApproversData(approversArr) {
        if(Array.isArray(approversArr)) {
            return  approversArr.map(approver => {
                return {
                    'Id': approver.UserId
                    ,'Name': approver.UserName
                    ,'Email': approver.Email
                    ,'UserAvatar': approver.Avatar
                };
            });
        }
        return [];
    }

    filterApprovers(filter, approvers) {
        const reg = new RegExp(filter,'i');
        if(Array.isArray(approvers)) {
            return approvers.filter(approver => {
                return approver.Name.match(reg,'g') || approver.Email.replace(/@(\w)+((\.\w{2,3}){1,3})$/g,'').match(reg,'g');
            });
        }
        return [];
    }

    clearState() {
        this.setState({ approvers: this.defaultUsers });
    }

    fetchSearchUsers(inVal) {
        if(this.selfFilter) {
            this.setState({ approvers: this.filterApprovers(inVal, this.defaultUsers) });
        }else {
            const params = {
                method: 'GET',
                credentials: 'same-origin'
            };

            const { translation } = this;

            const failureCallBack = function(res) {
                let tipInfo = { message: translation.searchFailed, type: 'error' };
                if (res.isOffLine) {
                    res['type'] = 'error';
                    tipInfo = res;
                }
                this.props.actions.showTip(tipInfo);
            }.bind(this);

            const successCallBack = function(data) {
                this.assigneeType = data.assigneeType;
                this.assigneeExpr = data.assigneeExpr;
                const res = data.approvers;
                this.setState({ approvers: this.formatApproversData(res) });
            }.bind(this);

            window.CommonFetch(this.getFetchUrl(inVal), params, successCallBack, failureCallBack, this.props.analysisData);
        }

        //this.setState({approvers: this.formatApproversData(sUsers)});
    }

    render() {
        const { cmp_data, ...others } = this.props;
        const cmpData = Object.assign({},cmp_data,{ singleSelect: this.state.singleSelect });
        return (<Staff {...others} cmp_data={cmpData}
                                    defaultUsers={this.defaultUsers}
                                    allUsers={this.state.approvers}
                                    clearState={this.clearState}
                                    fetchSearchUsers={this.fetchSearchUsers}
                                    hasDefaultSource
                                    isReadOnly={false}
                                    onChange={this.handleAppointApproversChange}
                                    avatars={this.state.appointApproversAvatars}
                                    text={this.state.appointApproversText}
                                    value={this.state.appointApproversValue} />);
    }
}

export default NextApprover;



// WEBPACK FOOTER //
// ./src/components/Field_Components/NextApprover/NextApprover.js